module.exports = __webpack_public_path__ + "static/media/pointing-computer.88ea416c.jpg";